module.exports = __webpack_public_path__ + "img/banner_image.802e9ddc.png";